import { UserDto, CallDto } from '@act/shared/data-transfer-objects';
import { Typography } from '@mui/material';
import { timeFormatter } from '@act/shared/utilities';

interface DrawerTitleProps {
  member: UserDto;
  voiceCall: CallDto;
}

const DrawerTitle = ({ member, voiceCall }: DrawerTitleProps) => {
  return (
    <Typography variant="titleLarge">
      {`Call with ${member?.firstName || 'Unknown'} ${
        member?.lastName || 'Caller'
      }`}
      {' | '}
      {`${
        voiceCall?.timeStarted
          ? `${timeFormatter.epochToHumanReadableDate({
              date: voiceCall?.timeStarted,
              includeTime: false,
            })} | ${timeFormatter
              .epochToHumanReadableTime(voiceCall?.timeStarted, true)
              ?.toLocaleLowerCase()}`
          : 'Unknown'
      } - ${
        voiceCall?.timeEnded
          ? timeFormatter
              .epochToHumanReadableTime(voiceCall?.timeEnded, true)
              ?.toLocaleLowerCase()
          : 'Unknown'
      }`}
    </Typography>
  );
};

export default DrawerTitle;
